module.exports = __webpack_public_path__ + "img/trainer-card.1c3b2b37.webp";